import { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const CMSContext = createContext();

export const useCMS = () => useContext(CMSContext);

const defaultContent = {
  heroBadge: "مقدمة من لباب سكول (Lobab School)",
  heroTitle: "الهوية ليست ما تراه العين",
  heroHighlight: "بل ما تشعر به",
  heroSubtitle: "انضم إلى دورة \"بناء الهوية البصرية الاحترافية\" في لباب سكول. انتقل من \"مصمم تمرينات\" إلى مصمم محترف يدير مشاريع الهوية بعقلية استراتيجية جاهزة للسوق بإشراف المدرب أصيل العامري.",
  heroButtonText: "ابدأ رحلتك الآن",
  heroSecondaryButtonText: "استكشف الخطة",
  youtubeVideoId: "7K8A8Zxp1mg",
  announcementTitle: "عرض الإطلاق:",
  announcementText: "احجز مقعدك بـ",
  announcementPrice: "$40",
  announcementOldPrice: "$50",
  announcementDurationDays: "5",
  announcementStartTime: "",
  announcementVersion: 1,
  // ─── Offer Section Defaults ───
  offerEnabled: true,
  offerCourse1Name: "لب بناء الهوية البصرية",
  offerCourse1Price: "50",
  offerCourse1Image: "",
  offerCourse2Name: "لب التصميم بالفوتوشوب",
  offerCourse2Price: "10",
  offerCourse2Image: "",
  offerOldPrice: "65",
  offerNewPrice: "50",
  offerDurationHours: "48",
  offerStartTime: "",
  offerWhatsappNumber: "",
};

export const CMSProvider = ({ children }) => {
  const [content, setContent] = useState(() => {
    if (typeof window !== 'undefined') {
      const cached = localStorage.getItem('lobab_cms_cache');
      if (cached) {
        try {
          return { ...defaultContent, ...JSON.parse(cached) };
        } catch (e) {
          console.error("Failed to parse cached CMS data", e);
        }
      }
    }
    return defaultContent;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'settings', 'landing_page'), (docSnap) => {
      if (docSnap.exists()) {
        const newData = docSnap.data();
        setContent(prev => {
          const merged = { ...prev, ...newData };
          localStorage.setItem('lobab_cms_cache', JSON.stringify(merged));
          return merged;
        });
      }
      setLoading(false);
    }, (error) => {
      console.error("Error fetching CMS settings:", error);
      setLoading(false);
    });

    return () => unsub();
  }, []);

  const updateContent = async (newContent) => {
    try {
      await setDoc(doc(db, 'settings', 'landing_page'), newContent, { merge: true });
    } catch (error) {
      console.error("Error updating CMS settings:", error);
      throw error;
    }
  };

  return (
    <CMSContext.Provider value={{ content, loading, updateContent }}>
      {children}
    </CMSContext.Provider>
  );
};
